// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Location/';
export const LocationActionTypes = {
  LOCATION: ActionHelper.createActionTypes(actionTypePrefix, 'LOCATION'),
};
